<template>
  <Card
    class="mx-auto shadow-xl
    transform transition-all md:max-w-lg sm:w-full sm:p-6"
    role="dialog"
    aria-modal="true"
    aria-labelledby="modal-headline"
  >
    <form action="" @submit.prevent="onSubmit">
      <div>
        <div
          class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-vectric"
        >
          <svg
            class="h-6 w-6 text-darkBlue"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
            ></path>
          </svg>
        </div>
        <div class="mt-3 sm:mt-5">
          <h3
            class="text-lg text-center leading-6 font-semibold uppercase tracking-tight text-darkBlue"
            id="modal-headline"
          >
            Start a Topic
          </h3>
          <div class="mt-2">
            <p class="text-sm  text-center leading-5 text-gray-500">
              Suggest a topic for discussion
            </p>
          </div>
          <div class="mt-2">
            <div class="mt-1 relative rounded-md shadow-sm">
              <input
                id="topic"
                class="form-input block w-full sm:text-sm sm:leading-5"
                placeholder="Topic Title"
                v-model="topic"
              />
            </div>
          </div>

          <div class="mt-2">
            <div class=" flex rounded-md shadow-sm">
              <textarea
                v-model="body"
                id="about"
                rows="6"
                class="form-textarea block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                placeholder="Say more about this..."
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-5 sm:mt-6">
        <span class="flex w-full rounded-md shadow-sm">
          <button
            type="submit"
            class="standard-btn w-full"
            :disabled="isDisabled"
          >
            Post
          </button>
        </span>
      </div>
    </form>
  </Card>
</template>

<script>
import { auth, firebase, topicsCollection } from "../utils/firebase";
import Card from "./shared/Card.vue";

export default {
  name: "NewTopicModal",
  components: { Card },
  data() {
    return {
      topic: "",
      body: ""
    };
  },
  computed: {
    isDisabled() {
      return (
        this.topic === undefined ||
        this.topic == null ||
        this.topic.trim().length === 0
      );
    }
  },
  methods: {
    onSubmit() {
      //TODO: some verification

      topicsCollection
        .add({
          topic: this.topic,
          body: this.body,
          user: auth.currentUser.uid,
          approved: false,
          userDisplay: auth.currentUser.displayName,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        })
        .then(() => {
          this.$store.dispatch(
            "setFlashMessage",
            "Thanks for suggesting a topic. We will just take a moment to approve your suggestion"
          );
          window.scrollTo({ top: 0, behavior: "smooth" });
          this.$emit("topic-added");
        })
        .catch(error => console.error("Error adding a document", error));
    }
  }
};
</script>

<style scoped></style>
